import React from 'react';
import PropTypes from 'prop-types';
import './AppLoader.scss';

const AppLoader = ({ style, className, color = '' }) => (
  <div className={`AppLoader ${className}`} style={style}>
    <div className={`AppLoader__${color ? color : 'default'}`} />
  </div>
);

AppLoader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string,
};

export default AppLoader;
